import { jsx as _jsx } from "react/jsx-runtime";
import { Pause as PauseIcon, PlayFilled as PlayIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { PLAY_PAUSE_BUTTON } from "~/constants/testIDs";
export const PlayPauseButton = /*#__PURE__*/ memo((param)=>{
    let { onPlayPause, isPlaying } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        className: "mr-0 md:mr-2",
        "data-testid": PLAY_PAUSE_BUTTON,
        label: isPlaying ? "Pause" : "Play",
        onClick: onPlayPause,
        size: "large",
        children: isPlaying ? /*#__PURE__*/ _jsx(PauseIcon, {
            className: "size-6"
        }) : /*#__PURE__*/ _jsx(PlayIcon, {
            className: "size-6"
        })
    });
});
PlayPauseButton.displayName = "PlayPauseButton";
